// Thrown when s3 upload fails  - de-duplicates error toasts for gig claims
export class EvidenceUploadError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "EvidenceUploadError";
  }
}
